<!--
  ~ Copyright (C) 2025 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

<div class="chart-dashboard">
  <p class="chart-dashboard-title">{{ 'translations.analytics.charts.dailyViews.title' | transloco }}</p>

  <div class="chart-dashboard__header">
    <div class="chart-dashboard__metrics">
      <div class="metric-item">
        <mat-icon class="metric-icon">visibility</mat-icon>
        <div class="metric-content">
          <span class="metric-value">{{ totalViews }}</span>
          <span class="metric-label">{{ 'translations.analytics.charts.dailyViews.totalVisits' | transloco }}</span>
        </div>
      </div>

      <div class="metric-item">
        <mat-icon class="metric-icon">people</mat-icon>
        <div class="metric-content">
          <span class="metric-value">{{ uniqueViewers }}</span>
          <span class="metric-label">{{ 'translations.analytics.charts.dailyViews.uniqueVisitors' | transloco }}</span>
        </div>
      </div>

      <div class="metric-item" *ngIf="uniqueViewers > 0">
        <mat-icon class="metric-icon">repeat</mat-icon>
        <div class="metric-content">
          <span class="metric-value">{{ avgViewsPerUser }}</span>
          <span class="metric-label">{{ 'translations.analytics.charts.dailyViews.avgVisitsPerUser' | transloco }}</span>
        </div>
      </div>

      <div class="metric-item" *ngIf="peakViewDay">
        <mat-icon class="metric-icon">show_chart</mat-icon>
        <div class="metric-content">
          <span class="metric-value">{{ peakViewDay }}</span>
          <span class="metric-label">{{ 'translations.analytics.charts.dailyViews.peakVisitsDay' | transloco }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="chart-dashboard__canvas">
    <canvas baseChart [data]="lineChartData" [options]="lineChartOptions" [type]="'line'"></canvas>
  </div>
</div>
